export * from './written-foto-kategorie.event.interface';
